import { render, staticRenderFns } from "./_SpaceCapacity.vue?vue&type=template&id=40de0174"
import script from "./_SpaceCapacity.vue?vue&type=script&lang=ts"
export * from "./_SpaceCapacity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports